export default __webpack_public_path__ + "static/media/ally_l1.cbfcc09b.png";